<template>
    <form
        class="form basic-form trip-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <div class="form-field">
            <label for="name">Name:</label>
            <input
                id="name"
                v-model="form.name.value"
                type="text"
                autocomplete="nickname"
            />
            <FormError :errors="errors.name" />
        </div>

        <div class="form-field">
            <label for="email">Email:</label>
            <input
                id="email"
                v-model="form.email.value"
                type="email"
                autocomplete="email"
            />
            <FormError :errors="errors.email" />
        </div>

        <div class="form-field">
            <label for="password">Password:</label>
            <input
                id="password"
                v-model="form.password.value"
                type="password"
                autocomplete="new-password"
            />
            <FormError :errors="errors.password" />
        </div>

        <div class="form-field">
            <label for="password_confirmation">Password confirmation:</label>
            <input
                id="password_confirmation"
                v-model="form.password_confirmation.value"
                type="password"
                autocomplete="new-password"
            />
            <FormError :errors="errors.password_confirmation" />
        </div>
        <div class="form-buttons vertical">
            <TurnstileWidget
                ref="turnstileWidget"
                class="form-widget"
                @verify="onVerify"
                @expire="onExpire"
            />
            <Bttn
                id="submit-register"
                type="submit"
                :disabled="form.token.value === ''"
                >Save</Bttn
            >
        </div>
        <p class="form-notice">
            By registering you agree to our
            <router-link to="/privacy">privacy policy</router-link>.
        </p>
        <div class="form-buttons vertical">
            <hr />
            <GoogleButton @click="googleLogin">
                Login with Google
            </GoogleButton>
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";
import GoogleButton from "js/components/custom/GoogleButton";
import TurnstileWidget from "js/components/custom/TurnstileWidget";

export default {
    name: "RegisterForm",
    components: {
        FormError,
        GoogleButton,
        TurnstileWidget,
    },
    extends: BaseForm,
    data() {
        return {
            form: {
                name: {
                    value: "",
                },
                email: {
                    value: "",
                },
                password: {
                    value: "",
                },
                password_confirmation: {
                    value: "",
                },
                token: {
                    value: "",
                },
            },
        };
    },
    methods: {
        onVerify(token) {
            this.form.token.value = token;
        },
        onExpire() {
            this.form.token.value = "";
        },
        googleLogin(event) {
            event.preventDefault();
            window.location.href = "/google-auth/redirect";
        },
    },
};
</script>
